const categories = [
  { text: "\"Confidential\" services", info: "" },
  { text: "Inclusive or feminist language", info: "May be used to create a false sense of neutrality or supportiveness while concealing an anti-abortion agenda." },
  { text: "\"Non-judgmental\" services", info: "" },
  { text: "Disclaimer about not referring for abortion", info: "" },
  { text: "Picture of sad woman", info: "" },
  { text: "Picture of woman hugging knees", info: "" },
  { text: "Picture of hetero couple/family", info: "" },
  { text: "Free pregnancy tests", info: "" },
  { text: "\"Earn while you learn\" programs", info: "" },
  { text: "Ultrasound services", info: "" },
  { text: "Baby boutique / free baby supplies", info: "" },
  { text: "Post-abortion support", info: "" },
  { text: "Parenting education", info: "" },
  { text: "Sex education", info: "" },
  { text: "Programs just for men", info: "" },
  { text: "Page about adoption", info: "" },
  { text: "Mentions \"abortion pill reversal\"", info: "Promotes a medically unproven and potentially unsafe procedure that claims to reverse medication abortions." },
  { text: "Abortion is \"difficult\"", info: "Frames abortion as inherently traumatic, which can be misleading or manipulative." },
  { text: "Lists several abortion \"risks\"", info: "May exaggerate, misrepresent, or entirely fabricate medical risks to discourage abortion." },
  { text: "\"About Us\" section has religious language", info: "" },
  { text: "God/Lord/Jesus is mentioned", info: "" },
  { text: "Mentions churches as funders", info: "" },
  { text: "Live chat box", info: "" },
  { text: "Testimonial video for the centre", info: "" },
  { text: "Picture of pregnancy test", info: "" },
  { text: "Picture of a baby", info: "" },
  { text: "Picture of woman in silhouette", info: "" },
  { text: "STI testing", info: "" },
  { text: "Member of Cdn Assoc. of Christian Charities", info: "Indicates a religious affiliation that may influence the centre’s counselling approach or bias." },
  { text: "Dead link", info: "Link does not lead to its supposedly intended destination; suggests poor credibility, lack of transparency, or outdated information." },
  { text: "Bogus link", info: "Leads to \"false\" websites or information that lack credibility; misleads users or signals intentional misinformation." },
  { text: "Mentions \"post-abortion distress\"", info: "A pseudo-medical claim not supported by scientific evidence which implies that psychological harm is inevitable after abortion." },
  { text: "Says artificial contraception is unreliable", info: "" },
  { text: "Advocates for abstinence", info: "" },
  { text: "Advocates against sex outside of marriage", info: "" },
  { text: "Has charitable status", info: "Allows for government benefits and can lend an appearance of legitimacy or neutrality despite the organization’s anti-choice ideological stance." },
  { text: "Phone number appears +3 times on a single page", info: "" },
  { text: "Close up picture of hands", info: "" },
  { text: "Says most women regret their abortions", info: "" },
  { text: "Says they support choice", info: "" }
]


export default categories;